import { useMemo } from 'react';
import { graphApi } from '.';

export const useFindCoWorkers = (
  search: string,
  {
    locations,
    excludeLocations,
  }: { locations?: string[]; excludeLocations?: string[] } = {}
) => {
  const searchStr = search.toLowerCase().trim();
  let locationFilter = '';

  if (locations?.length) {
    const locationList = locations.map((loc) => `'${loc}'`).join(',');
    locationFilter = `officeLocation in (${locationList})`;
  }

  if (excludeLocations?.length) {
    const locationList = excludeLocations.map((loc) => `'${loc}'`).join(',');
    locationFilter = `officeLocation ne ${locationList}`;
  }

  const { error, data, isLoading } = useFindGraphUsersQuery({
    filter: locationFilter,
    search: `"displayName:${searchStr}" OR "mail:${searchStr}"`,
    orderBy: 'displayName',
    select: 'id,displayName,mail,givenName,surname',
  });

  const users = (data?.value || []).filter(({ displayName, mail }) => {
    if (!displayName || !mail) {
      return false;
    }

    return `${displayName} ${mail}`.match(new RegExp(searchStr.trim(), 'i'));
  });

  return useMemo(
    () => ({ isLoading, error, data: users }),
    [users, isLoading, error]
  );
};

export const {
  useGetUserProfileQuery,
  useGetUserProfileImageQuery,
  useGetUserDirectReportsQuery,
  useFindGraphUsersQuery,
} = graphApi;
